// extracted by mini-css-extract-plugin
export default {"badge":"FvVideoEngagement_badge__QR-VV","separator":"FvVideoEngagement_separator__k82WR"};